// extracted by mini-css-extract-plugin
export default {"btn":"SearchBox_btn__TCLSj","input":"SearchBox_input__+6xEp","custom_select":"SearchBox_custom_select__pVmte","custom_select_mob":"SearchBox_custom_select_mob__Sz9j8"};